import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Cookies from 'universal-cookie'
import { verifyTokenAction } from '../modules/User'
import { API_HOSTNAME } from '../GlobalConfig'
import { getNotificationAction } from '../modules/Profile'

// Mock of an Auth method, can be replaced with an async call to the backend. Must return true or false
const isAuthenticated = (props) => {
  const cookies = new Cookies()
  const token = cookies.get('TKN_MINAPOLI')

  if (token && token !== '' && token !== 'undefined') {
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      mode: 'cors',
    }

    return fetch(`${API_HOSTNAME}/v1/user/auth/check`, options).then((res) => {
      if (res.status === 200) {
        res.json().then((result) => {
          props.verifyTokenAction(result)
          return true
        }).then(() => props.getNotificationAction())

        return true
      }

      return false
    }).catch((err) => {
      console.error(`Error verify token, ${err}`)
      return false
    })
  }

  // return false
  return false
}

const PUBLIC_ROOT = '/'

const AuthRoute = ({ component, ...props }) => {
  const path = props.path

  if (isAuthenticated(props)) {
    // If route is private, user proceeds, else route is public, redirect use to private root.
    return <Route {...props} component={component} />
  }
  // If route is private, user is redirected to app's public root, else user proceeds.
  return path.indexOf('/user') > -1
    ? <Redirect to={PUBLIC_ROOT} />
    : <Route {...props} component={component} />
}

AuthRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
  path: PropTypes.string.isRequired,
  verifyTokenAction: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => bindActionCreators({
  verifyTokenAction,
  getNotificationAction,
}, dispatch)

export default connect(undefined, mapDispatchToProps)(AuthRoute)



// WEBPACK FOOTER //
// ./src/containers/AuthRoute.js